import React, {useEffect, useState} from 'react';
import {FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Switch, TextField} from '@mui/material';
import Box from "@mui/material/Box";
import InputMask from "react-input-mask";
import {validateCpf} from "../../../../utils/validateCpf";
import {validateCnpj} from "../../../../utils/validateCnpj";
import Typography from "@mui/material/Typography";


export default function InputsBankDetails({dadosBancarios, setDadosBancarios}) {

    const [banco, setBanco] = useState(dadosBancarios ? dadosBancarios.banco : '')
    const [agencia, setAgencia] = useState(dadosBancarios ? dadosBancarios.agencia : '')
    const [numero, setNumero] = useState(dadosBancarios ? dadosBancarios.numero : '')
    const [tipoPessoa, setTipoPessoa] = useState(dadosBancarios ? dadosBancarios.tipoPessoa : 'F')
    const [tipoConta, setTipoConta] = useState(dadosBancarios ? dadosBancarios.tipoConta : 'CC')
    const [nome, setNome] = useState(dadosBancarios ? dadosBancarios.nome : '')

    const [taxId, setTaxId] = useState(dadosBancarios ? dadosBancarios.taxId : '')
    const [isCnpj, setIsCnpj] = useState(dadosBancarios ? dadosBancarios.taxId?.length === 18 : false)

    // effect que altera a variavel principal a partir dos states
    useEffect(() => {
        setDadosBancarios(prevData => {
            return {
                ...prevData,
                banco,
                agencia,
                numero,
                tipoPessoa,
                tipoConta,
                taxId,
                nome
            }
        })
    }, [banco, agencia, numero, tipoPessoa, tipoConta, taxId, nome])

    const toggleSwitch = () => {
        setIsCnpj(prevState => !prevState)
    }

    return <>
        <TextField
            id="nome"
            name="nome"
            label="Nome do Titular"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            variant="outlined"
            required
            inputProps={{
                maxLength: 100,
            }}
            fullWidth
        />

        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            {/*<div style={{marginRight: '10px'}}>*/}
            <Typography variant="body1">
                <b>Documento: &nbsp;</b>
            </Typography>
            <Typography variant="body1">
                CPF
            </Typography>
            <Switch
                checked={isCnpj}
                onChange={toggleSwitch}
                color="primary"
                inputProps={{'aria-label': 'alternar entre CNPJ e CPF'}}
            />
            <Typography variant="body1">
                CNPJ
            </Typography>
        </div>

        {!isCnpj ?
            <InputMask mask="999.999.999-99" value={taxId} maskChar={null}
                       onChange={(e) => setTaxId(e.target.value)}>
                {() =>
                    <TextField
                        required label="CPF" variant="outlined"
                        error={
                            taxId.length > 0 &&
                            (taxId.length < 14 || !validateCpf(taxId))
                        }
                        helperText={
                            taxId.length === 14 && !validateCpf(taxId)
                                ? 'CPF inválido!'
                                : taxId.length > 0 && taxId.length < 14
                                    ? 'CPF incompleto!'
                                    : ''
                        }
                        inputProps={{
                            maxLength: 14,
                            minLength: 14,
                        }}
                        fullWidth
                    />}
            </InputMask> :
            <InputMask mask="99.999.999/9999-99" value={taxId} maskChar={null}
                       onChange={(e) => setTaxId(e.target.value)}>
                {() =>
                    <TextField
                        required label="CNPJ" variant="outlined"
                        error={
                            taxId.length > 0 &&
                            (taxId.length < 18 || !validateCnpj(taxId))
                        }
                        helperText={
                            taxId.length === 18 && !validateCnpj(taxId)
                                ? 'CNPJ inválido!'
                                : taxId.length > 0 && taxId.length < 18
                                    ? 'CNPJ incompleto!'
                                    : ''
                        }
                        inputProps={{
                            maxLength: 18,
                            minLength: 18,
                        }}
                        fullWidth
                    />}
            </InputMask>
        }

        <TextField
            id="banco"
            name="banco"
            label='Código do Banco'
            value={banco}
            onChange={(e) => setBanco(e.target.value)}
            variant="outlined"
            required
            inputProps={{
                maxLength: 30,
            }}
            fullWidth
        />

        <TextField
            id="agencia"
            name="agencia"
            label="Agência"
            value={agencia}
            onChange={(e) => setAgencia(e.target.value)}
            variant="outlined"
            required
            inputProps={{
                maxLength: 10,
            }}
            fullWidth
        />

        <TextField
            id="numero"
            name="numero"
            label="Número"
            value={numero}
            onChange={(e) => setNumero(e.target.value)}
            variant="outlined"
            required
            inputProps={{
                maxLength: 20,
            }}
            fullWidth
        />

        {/*<FormControl component="fieldset" fullWidth required>*/}
        {/*    <FormLabel component="legend">Tipo de Pessoa</FormLabel>*/}
        {/*    <Box display="flex" justifyContent="center">*/}
        {/*        <RadioGroup*/}
        {/*            aria-label="tipoPessoa"*/}
        {/*            name="tipoPessoa"*/}
        {/*            value={tipoPessoa ? tipoPessoa : 'F'}*/}
        {/*            onChange={(e) => setTipoPessoa(e.target.value)}*/}
        {/*            row*/}
        {/*        >*/}
        {/*            <FormControlLabel value="F" control={<Radio/>} label="Física"/>*/}
        {/*            <FormControlLabel value="J" control={<Radio/>} label="Jurídica"/>*/}
        {/*        </RadioGroup>*/}
        {/*    </Box>*/}
        {/*</FormControl>*/}

        <FormControl component="fieldset" fullWidth required>
            <FormLabel component="legend">Tipo de Conta</FormLabel>
            <Box display="flex" justifyContent="center">
                <RadioGroup
                    aria-label="tipoConta"
                    name="tipoConta"
                    value={tipoConta ? tipoConta : 'CC'}
                    onChange={(e) => setTipoConta(e.target.value)}
                    row
                >
                    <FormControlLabel value="CC" control={<Radio/>} label="Corrente"/>
                    <FormControlLabel value="PG" control={<Radio/>} label="Pagamento"/>
                </RadioGroup>
            </Box>
        </FormControl>
    </>
}